export const LeadFunnels = {
  SITE_CODE_POSTAL: 'SITE_CODE_POSTAL',
  SITE_CARTE: 'SITE_CARTE'
}



// WEBPACK FOOTER //
// ./src/constants/LeadFunnels.js